module.exports = __webpack_public_path__ + "static/media/email-sentiment.f65d1326.png";